import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
  },
  {
    path: '/services',
    name: 'services',
    component: () => import(/* webpackChunkName: "services" */ '../views/ServicesView.vue')
  },
  {
    path: '/zhixing',
    name: 'zhixing',
    component: () => import(/* webpackChunkName: "zhixing" */ '../views/ZhixingView.vue')
  },
  {
    path: '/video-system',
    name: 'video-system',
    component: () => import(/* webpackChunkName: "video-system" */ '../views/VideoSystemView.vue')
  },
  {
    path: '/coupon-mall',
    name: 'coupon-mall',
    component: () => import(/* webpackChunkName: "coupon-mall" */ '../views/CouponMallView.vue')
  },
  {
    path: '/join',
    name: 'join',
    component: () => import(/* webpackChunkName: "join" */ '../views/JoinView.vue')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import(/* webpackChunkName: "contact" */ '../views/ContactView.vue')
  }
]

const router = new VueRouter({
  routes
})

export default router
